<template>
	<el-tabs type="border-card" v-model="tab">
		<el-tab-pane label="门店详情" name="lie" >
			<el-form class="shanghu" :model="mianban_shu" style="overflow-y: scroll; height: 90vh;margin-bottom: 50px;">
				<!-- <el-form-item label="Logo" label-width="100px">					
					<Shangwenjian v-model="mianban_shu.logo" anniu="选择图片" :leixing="tu"></Shangwenjian>
				</el-form-item> -->
				<!-- <el-form-item label="身份证(正)" label-width="100px" v-if="mianban_shu.qita">						
					<Shangwenjian v-model="mianban_shu.qita.shenfenzhen" anniu="选择图片" :leixing="tu"></Shangwenjian>
				</el-form-item>
				<el-form-item label="身份证(反)" label-width="100px" v-if="mianban_shu.qita">						
					<Shangwenjian v-model="mianban_shu.qita.shenfenfan" anniu="选择图片" :leixing="tu"></Shangwenjian>
				</el-form-item>
				<el-form-item label="营业执照" label-width="100px" v-if="mianban_shu.qita">						
					<Shangwenjian v-model="mianban_shu.qita.yingyezhao" anniu="选择图片" :leixing="tu"></Shangwenjian>
				</el-form-item>
				<el-form-item label="店铺昵称" label-width="100px">
					<el-input v-model="mianban_shu.ming"></el-input>
				</el-form-item>
				<el-form-item label="企业全称" label-width="100px">
					<el-input v-model="mianban_shu.gongsiming"></el-input>
				</el-form-item>
				<el-form-item label="客服电话" label-width="100px">
					<el-input style="width:100%" v-model="mianban_shu.dianhua" />
				</el-form-item>
				<el-form-item label="营业时间" label-width="100px" v-if="mianban_shu">
					  <el-time-select placeholder="起始时间" v-model="mianban_shu.yingyekaishishijian" :picker-options="{ start: '00:00', step: '00:30', end: '23:30' }"></el-time-select>
					  <el-time-select placeholder="结束时间" v-model="mianban_shu.yingyejieshushijian" :picker-options="{ start: '00:00', step: '00:30', end: '23:30', minTime: mianban_shu.yingyekaishishijian}"></el-time-select>
				</el-form-item> -->
				<!-- <el-form-item label="配送方式" label-width="100px">
					<el-radio-group v-model="mianban_shu.peisongfangshi">
					    <el-radio label="0">派送上门</el-radio>
					    <el-radio label="1">到店自提</el-radio>						   
					  </el-radio-group>
				</el-form-item> -->
				<!-- <el-form-item label="派送费" label-width="100px"  v-if="mianban_shu.qita">
					<el-input style="width:100%" v-model="mianban_shu.qita.paisongfei">
						<template slot="append">元</template>
					</el-input>						
				</el-form-item>
				<el-form-item label="佣金比例" label-width="100px"  v-if="mianban_shu.qita">
					<el-input style="width:100%" v-model="mianban_shu.qita.yongjin">
						<template slot="append">%</template>
					</el-input>						
				</el-form-item>
				<el-form-item label="地区" label-width="100px">
					<Dizhi v-model="mianban_shu.shengshiqu"></Dizhi>
				</el-form-item>
				<el-form-item label="详细地址" label-width="100px">
					<el-input style="width:100%" v-model="mianban_shu.dizhi" />
				</el-form-item>
				<el-form-item label="地图坐标" label-width="100px">
					<el-input style="width:40%" v-model="mianban_shu.jingdu">
						<template slot="append">经度</template>
					</el-input>
					<el-input style="width:40%" v-model="mianban_shu.weidu">
						<template slot="append">纬度</template>
					</el-input>
					<el-button @click="$refs.ditu.CSH(mianban_shu.jingdu,mianban_shu.weidu)">选择坐标</el-button>
				</el-form-item> -->
				
				<el-form-item label="超出距离不配送" label-width="140px">
					<el-input placeholder="距离"  v-model="mianban_shu.zuidajuli">
						<template slot="append">米</template>
					</el-input>
				</el-form-item>
				<el-form-item label="门店配送运费设置" label-width="140px">
					<div v-for="(jl,i) in mianban_shu.julilie" style="width: 40%;display: flex;margin: 10px ;">
						<el-input placeholder="配送范围"  v-model="jl.juli">
							<template slot="append">米内</template>
						</el-input>
						<el-input placeholder="配送费"  v-model="jl.yunfei">
							<template slot="append">(元)</template>
						</el-input>
						<el-button  type="danger"  @click="shangjuli(i)">删除</el-button>
					</div>
					<el-button @click="Julijia">添加配送范围</el-button>
					
				</el-form-item>
				<el-form-item label="简介" label-width="100px">
					<Bianjiqi v-model="mianban_shu.jianjie"></Bianjiqi>
				</el-form-item> 
				<div class="demo-drawer__footer">					
					<el-button type="primary" @click="Tijiao">确 定</el-button>
				</div>
			</el-form>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
	let that
	import Shangtu from '../../zujian/Shangtu.vue'
	import Dizhi from '../../zujian/Dizhi.vue'
	import Gaodeditu from '../../zujian/Gaodeditu.vue'
	import Bianjiqi from '../../zujian/Bianjiqi.vue'
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	export default {
		data() {
			return {
				so: {
					ye: 1,
					jitiao: 20,
					leixing: 1
				},
				tab:'lie',
				mianban_shu: {},
			}
		},
		components: {
			Shangtu,
			Gaodeditu,
			Dizhi,
			Bianjiqi,
			Shangwenjian
		},
		created() {
			that = this;
			that.CSH();
		},
		methods: {
			CSH() {
				this.$post('k=shanghu&c=xiangqing',function(s) {
					that.mianban_shu = s.shu;
				});
			},
			// 距离
			Julijia(){
				if(!that.mianban_shu.julilie){
					that.mianban_shu.julilie=[]
				}
				that.mianban_shu.julilie.push({juli:0,yunfei:0})
			},
			shangjuli(e){
				that.mianban_shu.julilie.splice(e,1)
			},
			Tijiao(){
				this.$post('k=shanghu&c=Xiugai', that.mianban_shu, function(s) {
					that.$xiaoxi(s.shu);
					if (s.shi == 1) {
						that.CSH();
					}
				});
			}
		},
	}
</script>

<style>
</style>